import { cn } from '@core/utils';
import type { ToastContainerProps } from 'react-toastify';
import { Slide, ToastContainer } from 'react-toastify';

type ToastProviderProps = Omit<ToastContainerProps, 'transition'>;

export const ToastProvider = ({
  className,

  position = 'bottom-center',
  draggable = true,
  ...restProps
}: ToastProviderProps) => {
  return (
    <ToastContainer
      draggable={draggable}
      stacked
      className={cn(
        'p-0',
        'max-[1279px]:!right-auto max-[1279px]:!left-1/2 max-[1279px]:!w-[calc(100%-32px)] max-[1279px]:!-translate-x-1/2',
        className,
      )}
      closeButton={false}
      draggableDirection="y"
      draggablePercent={20}
      position={position}
      theme="colored"
      toastClassName={cn(
        '!min-h-0 cursor-grab !bg-[rgba(0,0,0,0.7)] backdrop-blur-sm',
        'whitespace-pre-line rounded-pill px-20 py-12 font-400 !text-Gray-white typo-body4',
        'w-full overflow-hidden break-words',
        'max-[1279px]:!mx-auto max-[1279px]:!w-fit max-[1279px]:!max-w-full max-[1279px]:self-center max-[1279px]:!rounded-pill',
      )}
      transition={Slide}
      {...restProps}
    />
  );
};
